import { Field } from 'signer-app/types/editor-types';

/**
 * Finds the next field with a validation error, searching forward from the
 * current active field and wrapping around.
 *
 * Extracted from handleFieldsUnfilled in next-button.tsx so it can be
 * unit-tested independently.
 */
export function findNextFieldWithError(
  fields: Field[],
  activeFieldId: string | undefined,
  validationErrors: Record<string, { message: string }>,
): Field | undefined {
  const i = fields.findIndex((f) => f.id === activeFieldId);
  return fields
    .concat(fields)
    .slice(i + 1)
    .find((f) => f.required && !!validationErrors[f.id]);
}
